import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;

let supabase = null;

// Validate environment variables
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('❌ Missing Supabase environment variables');
  console.error('VITE_SUPABASE_URL:', supabaseUrl ? '✅ Set' : '❌ Missing');
  console.error('VITE_SUPABASE_ANON_KEY:', supabaseAnonKey ? '✅ Set' : '❌ Missing');
} else if (typeof createClient !== 'function') {
  console.error('❌ createClient is not a function. Check @supabase/supabase-js installation');
} else {
  try {
    supabase = createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
      }
    });
    
    if (supabase) {
      console.log('✅ Supabase client initialized successfully');
    } else {
      console.error('❌ Failed to create Supabase client - returned null/undefined');
    }
  } catch (error) {
    console.error('❌ Error creating Supabase client:', error);
    supabase = null;
  }
}

export { supabase };
